import { GridDataEntry } from 'controls/grid/gridDataEntry';
import React from 'react';
import { GridSelection } from 'controls/grid/gridSelection';
import { GridStore } from 'controls/grid/gridStore';

export enum ContextMenuSelection {
	currentItem,
	allSelectedPlusCurrent,
}

export type GridMenuAction<TDataItem extends GridDataEntry> = {
	id?: string;
	label: string;
	icon?: React.ReactNode;
	visible?: (selection: GridSelection<TDataItem>, store: GridStore<TDataItem>) => boolean;
	enabled?: (
		selection: GridSelection<TDataItem>,
		store: GridStore<TDataItem>,
	) => boolean | { enabled: boolean; reason: string };
	action: (
		selection: GridSelection<TDataItem>,
		store: GridStore<TDataItem>,
	) => void | Promise<void> | Promise<boolean> | boolean;
	//indicates if selection argument of an action should contain only just an item which user clicked on or all selected items plus clicked one
	contextMenuSelection?: ContextMenuSelection;
	disableSuccessNotification?: boolean;
	confirmation?: {
		singularQuestion: string;
		pluralQuestion?: string;
	};
};
